import { Icon } from '@iconify/react'
import { cn } from '@/lib/utils'

export interface DropdownOption {
  value: string
  label: string
}

interface DropdownSelectProps {
  value: string
  options: DropdownOption[]
  onChange: (value: string) => void
  placeholder?: string
  className?: string
  align?: 'left' | 'right'
  icon?: string
}

export function DropdownSelect({
  value,
  options,
  onChange,
  placeholder = 'เลือกตัวเลือก',
  className,
  align = 'left',
  icon,
}: DropdownSelectProps) {
  const selectedOption = options.find((option) => option.value === value)
  const displayLabel = selectedOption?.label || placeholder

  return (
    <details className={cn('relative group', className)}>
      <summary className="list-none w-full">
        <div className="h-10 px-3 rounded-lg border border-slate-200 bg-white flex items-center gap-2 text-sm cursor-pointer hover:border-slate-300 transition-colors">
          {icon && <Icon icon={icon} className="w-4 h-4 text-slate-500" />}
          <span
            className={cn(
              'flex-1 min-w-0 truncate text-sm',
              selectedOption ? 'text-slate-700' : 'text-slate-500',
            )}
          >
            {displayLabel}
          </span>
          <Icon
            icon="solar:alt-arrow-down-line-duotone"
            className="w-4 h-4 text-slate-400 transition-transform group-open:rotate-180"
          />
        </div>
      </summary>

      <div
        className={cn(
          'absolute top-[calc(100%+0.5rem)] z-30 min-w-[14rem] rounded-xl border border-slate-200 bg-white p-2 shadow-xl',
          align === 'right' ? 'right-0' : 'left-0',
        )}
      >
        <div className="space-y-1 max-h-64 overflow-auto">
          {options.map((option) => {
            const isSelected = option.value === value

            return (
              <button
                key={option.value || '__empty__'}
                type="button"
                onClick={(event) => {
                  onChange(option.value)
                  event.currentTarget.closest('details')?.removeAttribute('open')
                }}
                className={cn(
                  'w-full rounded-lg px-2.5 py-2 text-sm text-left transition-colors flex items-center justify-between gap-2',
                  isSelected
                    ? 'bg-blue-50 text-blue-700'
                    : 'text-slate-700 hover:bg-slate-50',
                )}
              >
                <span className="truncate">{option.label}</span>
                {isSelected && (
                  <Icon
                    icon="solar:check-circle-bold-duotone"
                    className="w-4 h-4 flex-shrink-0"
                  />
                )}
              </button>
            )
          })}
        </div>
      </div>
    </details>
  )
}
